import React, { memo, PropsWithChildren } from 'react';
import { Button } from '../ui/button';
import { cn } from 'lib/utils';

interface Props extends PropsWithChildren {
  title?: string;
  submitText?: string;
  className?: string;
  onSubmit?: (e: React.FormEvent<HTMLFormElement>) => void;
  disabled?: boolean;
  loading?: boolean;
}

function Form(props: Props) {
  const {
    title,
    submitText = 'Сохранить',
    className = '',
    onSubmit,
    children,
    disabled = false,
    loading = false,
  } = props;

  return (
    <form
      onSubmit={onSubmit}
      className={cn('flex flex-col gap-4 bg-white rounded-lg p-6', className)}
    >
      <div className="flex flex-col gap-2">
        {title && (
          <h2 className="text-lg font-semibold text-foreground">{title}</h2>
        )}
        {children}
      </div>
      {onSubmit && (
        <Button
          disabled={disabled || loading}
          className="w-full mt-2"
          type="submit"
        >
          {loading ? 'Сохраняем...' : submitText}
        </Button>
      )}
    </form>
  );
}

export default memo(Form);
